export function showCompensationRange(user) {
  if (!user.compensationRange || user.compensationRange.length < 2) {
    return false;
  }
  const [min, max] = user.compensationRange;
  if (max < 25000) {
    return false;
  }
  if (min < 1000 && max > 150000) {
    return false;
  }
  if (user.yearsOfWorkExperience <= 3 && max > 90000) {
    return false;
  }
  return true;
}
